



















































































// Vue-related and Decorators
import { Component, Watch } from 'vue-property-decorator';
// Models
import type { PMAppliedLesson } from '@/models/pmappliedlesson';
import type { Project } from '@/models/project';

// Components
import AppliedLessonTable from '@/components/worksheets/AppliedLessonTable.vue';
import ColumnsFilter from '@/components/worksheets/ColumnsFilter.vue';
import FormDynamicFieldMultiselect from '@/components/form/FormDynamicFieldMultiselect.vue';
import PMPhaseWorksheet from '@/components/projects/fields/PMPhaseWorksheet.vue';
import ProjectViewFilterPanel from '../filters/ProjectViewFilterPanel.vue';
import WorksheetUpdateLessonModal from '@/components/worksheets/WorksheetUpdateLessonModal.vue';

// Web Services
import { pmAppliedLessonWebservice } from '@/webservices/pmappliedlesson';

// Helpers, Utilities, and Miscellaneous
import { createAppliedLessonsFilter } from '@/helpers/createAppliedLessonsFilter';

import ProjectViewListBase from './ProjectViewListBase'; // Update the path accordingly
import { debounce } from 'lodash';
import { showSuccessNotification } from '@/helpers/showSuccessNotification';
import { AppliedLessonType } from '@/enums/AppliedLessonType';
import { ResolvedEnum } from '@/helpers/filter/appliedLessons/filterAppliedLessonsResolved';
import { CheckedEnum } from '@/helpers/filter/appliedLessons/filterAppliedLessonsChecked';

@Component({
    name: 'ProjectViewPMList',
    components: {
        FormDynamicFieldMultiselect,
        ColumnsFilter,
        PMPhaseWorksheet,
        AppliedLessonTable,
        WorksheetUpdateLessonModal,
        ProjectViewFilterPanel,
    },
})
export default class ProjectViewPMList extends ProjectViewListBase {
    private AppliedLessonType = AppliedLessonType;

    private toggledPMPhases = [];
    private appliedLessonToUpdate: PMAppliedLesson = {} as PMAppliedLesson;
    private selectedTabs: string[] = ['pm'];

    private DEBOUNCE_APPLY_UPDATE_INTERVAL = 0; // milliseconds
    private DEBOUNCE_RELOAD_WORKSHEET_INTERVAL = 10; // milliseconds
    private DEBOUNCE_UPDATE_NOTIFICATION_INTERVAL = 2000; // milliseconds

    private debouncedUpdate = debounce(this.applyUpdate, this.DEBOUNCE_APPLY_UPDATE_INTERVAL);
    private debouncedReload = debounce(this.reloadWorksheet, this.DEBOUNCE_RELOAD_WORKSHEET_INTERVAL);
    private debouncedUpdateNotification = debounce(this.updateNotification, this.DEBOUNCE_UPDATE_NOTIFICATION_INTERVAL);

    private isUpdating: boolean = false;

    mounted() {
        this.resetFilter();
        this.loadPhases();
        this.loadTopics();
        this.selectedPmPhases = this.project.pmphases;
    }

    private async applyUpdate(lesson: PMAppliedLesson) {
        await pmAppliedLessonWebservice.update(lesson as PMAppliedLesson).catch(() => {
            this.showErrorNotification('toastMessages.error.worksheet');
        });
        this.debouncedUpdateNotification();
        this.debouncedReload();
    }

    @Watch('project')
    private onProjectChanged(newProject: Project, oldProject: Project | null) {
        if (!oldProject || newProject.id !== oldProject.id) {
            this.resetFilter();
        }
    }

    private resetFilter() {
        this.tableColumns = createAppliedLessonsFilter(this.companySetting);
        this.filterResolved = ResolvedEnum.NotResolved;
        this.filterChecked = CheckedEnum.All;
        if (this.companySetting.feature_dynamic_worksheet_field) {
            this.fetchAllDynamicFields();
            this.selectedDynamicFields = this.dynamicFields;
        }
        this.selectedPmPhases = this.pmPhases;
    }

    private toggleUpdateAppliedLessonModal(value) {
        this.appliedLessonToUpdate = value;
        console.log(this.project);
        let worksheet = null;
        for (const pmphase of this.project.pmphases as any[]) {
            if (pmphase.worksheet && pmphase.worksheet.id === value.pm_worksheet_id) {
                worksheet = pmphase.worksheet;
                break;
            }
        }
        this.toggleModal(WorksheetUpdateLessonModal, {
            type: AppliedLessonType.PMAppliedLesson,
            worksheet,
            saved: this.refreshSelectedProject,
            appliedLessonToUpdate: this.appliedLessonToUpdate,
        });
    }

    private updateNotification() {
        showSuccessNotification('toastMessages.update.worksheet');
    }

    private async reloadWorksheet() {
        this.isUpdating = true;
        await this.refreshSelectedProject();
        this.isUpdating = false;
    }
}
